<template>
  <div class="origin-site">
    <div style="margin-top: 24px">
      <div class="row-line">
        <loginInput
          :label="$t('allDomain.domain')"
          tipStyle="color: #A1A7C4;margin-left: -12px;"
          inputStyle="width: 600px;"
          realInputStyle="width: 600px; height: 40px;"
          :inputValue="ipWhiteListItem"
          disabled
          @changeInput="(e) => (ipWhiteListItem = e)"
        />
      </div>
    </div>

    <div class="lan-dong">
      <span class="text-gray-style">{{ $t("allDomain.originSettings") }}</span>

      <div style="margin-top: 24px">
        <el-input
          type="textarea"
          :rows="5"
          placeholder="11.22.33.44:80"
          v-model="IPBalcktextarea"
        >
        </el-input>
        <div style="margin-bottom: 15px; color: #666666; font-size: 14px">
          {{$t('allDomain.upstreamTip')}}
        </div>
      </div>
    </div>

    <div class="btn-commit" @click="commitClick">
      {{ $t("product.commit") }}
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import { apiHostEdit } from "@/service/requestRes";
import { upstream_str2list }from '@/utils/upstreams';

export default {
  props: {
    domainHost: String,
    serverJson: String,
  },
  data() {
    return {
      ipWhiteListItem: this.domainHost,
      IPBalcktextarea: "",
      server_json: '',
    };
  },

  watch: {
    server_json(val) {
    let serverJson1 = {};
      try {
        let str = '';
        serverJson1 = val && JSON.parse(val);
        const { upstreams } = serverJson1 || {};
        let myarray = upstreams && upstreams.map( upItem => {
            let myitem = [];
            myitem.push(upItem.addr)
            myitem.push(
              [upItem.port?upItem.port:'',upItem.isSSL?'s':''].join(''))
            return myitem.filter(x=>x).join(':')
        });
        this.IPBalcktextarea = myarray.join('\n');
      } catch(e) {
        console.error(e);
      }
    }
  },
  mounted(){
    this.server_json = this.serverJson;
  },  
  methods: {
    commitClick() {
        if (!this.IPBalcktextarea) {
             this.$message({
            message: "请输入源站设置",
            type: "error",
          });
            return;
        }
      const upstreams = {
        func: "upstreams",
        host: this.domainHost,
        upstreams: upstream_str2list(this.IPBalcktextarea),
      };

      this.configCNMethod(upstreams);
    },

    configCNMethod(obj) {
      apiHostEdit({
        ...obj,
        host: this.domainHost,
      }).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
          this.$message({
            message: '设置成功',
            type: "success",
          });
        } else {
          this.$message({
            message: msg,
            type: "error",
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.cenum-setting {
  padding: 21px 0;
  .cenue-title {
    font-family: PingFangSC-Semibold;
    font-size: 14px;
    color: #131523;
  }
  .lan-dong {
    margin-top: 28px;
    .checkbox-content {
      margin-top: 6px;
      display: flex;
      align-items: center;
    }
  }

  .margin-top {
    margin-top: -15px;
  }

  .row-line {
    display: flex;
    align-items: flex-end;
    margin-bottom: 36px;
    .new-add {
      padding: 8px 44px;
      width: 120px;
      height: 40px;
      background: #d9e4ff;
      border-radius: 4px;
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #1e5eff;
      cursor: pointer;
      margin-left: 10px;
      margin-bottom: 6px;
    }
  }
  .lan-dong-link {
    display: flex;
    margin-top: 24px;
  }
  .handle-first {
    cursor: pointer;
  }
}

.btn-commit {
  padding: 8px 44px;
  margin: 24px 0px;
  width: 120px;
  background: #d9e4ff;
  border-radius: 4px;
  font-family: PingFangSC-Semibold;
  font-size: 14px;
  color: #1e5eff;
  cursor: pointer;
}
</style>